import React, { FC } from 'react';

import { CatInAFlatLogo as CatInAFlatLogoIcon } from '@rover/icons';

const CatInAFlatLogo: FC = () => <CatInAFlatLogoIcon height={40} width={65} />;

export default CatInAFlatLogo;
